/**
 * @file WallClock.ts
 * @role Injectable source of Unix wall-clock milliseconds for local-time presentation.
 * @owns The browser/system Date.now boundary used by non-gameplay metadata.
 * @neverDoes Advance reel physics. Replace the monotonic GameClock. Schedule timers.
 * @invariants 13, 22.
 * @see src/core/time/GameClock.ts, src/scenes/ReelGameScene/FooterClockPresenter.ts
 */
export interface WallClock {
  nowMs(): number;
}

export class SystemWallClock implements WallClock {
  nowMs(): number {
    return Date.now();
  }
}
